const parseCookieName = (cookieName, updatedAt) => {
  return `pb-${cookieName}-${updatedAt ? Date.parse(updatedAt) : 0}`
}

export const setBannerCookie = (
  cookiesApi,
  cookieName,
  updatedAt,
  redisplayDuration = 1,
) => {
  if (typeof window === "undefined") {
    return
  }

  const savedCookieName = parseCookieName(cookieName, updatedAt)
  cookiesApi.set(savedCookieName, "true", {
    expires: redisplayDuration,
    path: "/",
    secure: window.location.protocol === "https:",
  })
}

export const checkBannerCookie = (cookiesApi, cookieName, updatedAt) => {
  if (typeof window === "undefined") {
    return
  }
  return cookiesApi.get(parseCookieName(cookieName, updatedAt))
}

export const withinDateRange = (startDate, endDate) => {
  const parsedStart = startDate ? Date.parse(startDate) : 0
  const parsedEnd = endDate ? Date.parse(endDate) : Infinity
  const now = Date.now()
  return now >= parsedStart && now <= parsedEnd
}

export const returnActivePromotionBanner = promotionBanner => {
  let activeBanner
  if (promotionBanner && promotionBanner?.length) {
    activeBanner = promotionBanner?.filter(
      banner =>
        withinDateRange(banner.startDate, banner.endDate) &&
        // Guard against empty/test entries (e.g. an "Untitled" banner with no
        // header/cta/details but a personalization experience attached) —
        // with no startDate/endDate they're always "in range" and the sort
        // below would otherwise promote them ahead of real banners.
        (banner?.header || banner?.cta || banner?.richTextDetails),
    )
    activeBanner = activeBanner
      .sort(function (a, b) {
        return (
          a?.ntExperiencesCollection?.items?.length -
          b?.ntExperiencesCollection?.items?.length
        )
      })
      .reverse()
  } else {
    activeBanner = null
  }
  return activeBanner
}
